import { useMutation } from '@tanstack/react-query';

import { authenticateAdmin } from '../api/adminAuthApi';

export function useAdminLogin() {
  return useMutation({
    mutationFn: ({ login, password }: { login: string; password: string }) =>
      authenticateAdmin(login, password),
  });
}
